import React, { useEffect, useState } from "react";
import "./ForgotPage.css";
import { Row, Container, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { postRequestcall } from "../../comman/util/postRequest";
import { FORGOT } from "../../constants/apiurl";
import FormgroupPage from "../../comman/formgroup/FormgroupPage";
import ButtonPage from "../../comman/button/ButtonPage";

function ForgotPage(props) {
  const emailRegex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  const { t } = useTranslation();
  const [errorMsg, setErrormsg] = useState("");
  const [inputevalue, setInputvalue] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    callSetHeaderTitle();
    // eslint-disable-next-line
  }, [props?.language]);
  const callSetHeaderTitle = () => {
    props?.fetchHeaderContent(t("pages.login.forgot"), "", "");
  };
  const inputValuechange = (e) => {
    setInputvalue(e.target.value);
    setErrormsg("");
  };

  const validation = () => {
    let checkValue = "";
    let error = "";
    if (!emailRegex.test(inputevalue)) {
      error = "pages.profile.email_address_valid";
      checkValue = "false";
    }
    if (inputevalue === "") {
      error = "pages.checkout.email_address_warn";
      checkValue = "false";
    }
    setErrormsg(error);
    if (checkValue === "false") {
      return false;
    } else {
      return true;
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    if (validation()) {
      let data = {
        email: inputevalue,
      };
      let forgotPasswordresponse = await postRequestcall(
        FORGOT + `?lang=${props?.language.toLowerCase()}`,
        "",
        data
      );
      if (forgotPasswordresponse?.status === 200) {
        toast.success(
          t("pages.Please check your mail for reset password notification")
        );
        setInputvalue("");
      } else if (forgotPasswordresponse.status === 400) {
        let response = await forgotPasswordresponse.json();
        toast.error(response.error);
      }
    }
  };

  const redirectTologin = () => {
    navigate("/login");
  };

  return (
    <>
      <section className="forgot-section common_login-section">
        <div className="forgot-container">
          <Container>
            <Row className="justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-10 col-xl-10">
                <div className="forgot-box common_box">
                  <Row>
                    <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                      <Form className="forgot-form">
                        <div className="form-header">
                          <h2>{t("pages.login.forgot")}</h2>
                          <h6>
                            {t("pages.Please enter your email address below")}
                          </h6>
                        </div>

                        <div className="form-content">
                          <FormgroupPage
                            className="form-group"
                            label={''}
                            value={inputevalue}
                            onChange={(e) => inputValuechange(e)}
                            placeholder={t(
                              "pages.checkout.email_address_warn"
                            )}
                            error={t(errorMsg)}
                            require={false}
                          />
                          <ButtonPage
                              className="button-submit w-100 my-3"
                              onClick={(e) => resetPassword(e)}
                              Text={t("pages.Reset Password")}
                            />
                        </div>

                        <div className="loginque text-center">
                          <h6>
                            {t("pages.signup.haveaccount")}{" "}
                            <span onClick={() => redirectTologin()}>
                              {t("pages.signup.login")}
                            </span>
                          </h6>
                        </div>
                      </Form>
                    </div>
                  </Row>
                </div>
              </div>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => ({
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchHeaderContent })(ForgotPage);
